module.exports = __webpack_public_path__ + "assets/img/Arty_cover.0b28f6ae-ps.jpg";